import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useOTP } from './OTPContext';

const AdminProtectedRoute = ({ component: Component, ...rest }) => {
  const { isOTPVerified } = useOTP();

  return (
    <Route
      {...rest}
      render={props =>
        isOTPVerified ? (
          <Component {...props} />
        ) : (
          <Redirect to="/admin/2fa" />
        )
      }
    />
  );
};

export default AdminProtectedRoute; 